import { createFileRoute } from "@tanstack/react-router";
import { SeriesDetailsModule } from "@/modules/SeriesDetails";

export const Route = createFileRoute("/_default/series/$series/")({
  component: SeriesDetailsModule,
});
